// @ts-nocheck
/* eslint-disable */

import React from 'react';
import ViewEntity from 'app/components/CRUD/ViewEntity';

import {
  CONFIG_PATHS,
  CONFIG_ROUTES,
  getCurrentLanguageCode,
} from 'app/configuration/configuration-api';

const ViewFareMediaIssuer: React.FC = () => {
  return (
    <ViewEntity
      pageTitle="FareMediaIssuerInfo"
      fetchApiUrl={CONFIG_PATHS.fareMediaIssuerById}
      fetchApiMethod="GET"
      dataPath="data.data"
      fields={[
        { name: 'en_issuer_name', labelKey: 'NameEnglish', type: 'text' },
        { name: 'ar_issuer_name', labelKey: 'NameArabic', type: 'text' },
        {
          name: 'phone',
          labelKey: 'Phone',
          type: 'custom',
          render: data => data.phone || '-',
        },
        {
          name: 'email',
          labelKey: 'Email',
          type: 'custom',
          render: data => data.email || '-',
        },
        {
          name: 'address',
          labelKey: 'Address',
          type: 'custom',
          render: data => data.address || '-',
        },
        {
          name: 'organisations_count',
          labelKey: 'AssignedOrganisations',
          type: 'custom',
          render: data =>
            data.organisations_count === undefined ? '-' : data.organisations_count,
        },
        {
          // Cards issued through any of this issuer's assignments. Shown here so
          // the reason a delete is refused is visible before it is attempted.
          name: 'fare_media_count',
          labelKey: 'IssuedFareMedia',
          type: 'custom',
          render: data =>
            data.fare_media_count === undefined ? '-' : data.fare_media_count,
        },
        { name: 'created_at', labelKey: 'CreatedAt', type: 'date' },
        { name: 'updated_at', labelKey: 'UpdatedAt', type: 'date' },
      ]}
      editUrl={`${CONFIG_ROUTES.fareMediaIssuers}/:id/edit`}
      deleteApiUrl={CONFIG_PATHS.fareMediaIssuerById}
      deleteApiMethod="DELETE"
      backUrl={CONFIG_ROUTES.fareMediaIssuers}
      backButtonLabel="Back"
      buildTitle={data =>
        getCurrentLanguageCode() === 'en-us'
          ? data.en_issuer_name
          : data.ar_issuer_name
      }
      buildDeleteConfirmMessage={(data, additionalData, currentLanguageCode, intl) => {
        const name =
          currentLanguageCode === 'en-us' ? data.en_issuer_name : data.ar_issuer_name;
        return `${intl.formatMessage({ id: 'AreYouSureDeleteFareMediaIssuer' })} ${name}?`;
      }}
      showEditButton={true}
      showDeleteButton={true}
      subsystemName="FareMediaIssuers"
      permissionSystem="masterConfig"
    />
  );
};

export default ViewFareMediaIssuer;
